import React from 'react';

import introGraphicNewFindings from '../../../assets/intro-report-graphic-new-findings.svg';
import introGraphicNoteToSelf from '../../../assets/intro-report-graphic-note-to-self.svg';
import introGraphicWorkLog from '../../../assets/intro-report-graphic-work-log.svg';
import {useViewer} from '../../../state/viewer/hooks';
import BlankPage from './../../BlankPage';

type BlankReportPageProps = {
  createReport: (location: string) => void;
};
export const BlankReportPage = ({createReport}: BlankReportPageProps) => {
  const viewer = useViewer();
  const isAnonymous = viewer == null;

  return (
    <BlankPage
      header="Reports"
      subheader="How many discoveries were lost because they weren't written down?"
      info="Use Reports for quick notes and custom dashboards. Save charts, annotate findings, and share results with colleagues."
      graphics={[
        {
          src: introGraphicNoteToSelf,
          alt: 'note-to-self',
        },
        {
          src: introGraphicWorkLog,
          alt: 'work-log',
        },
        {
          src: introGraphicNewFindings,
          alt: 'new-findings',
        },
      ]}
      secondaryAction={{
        content: 'See example',
        href: '/wandb/wandb_example/reports/How-many-discoveries-were-lost-because-they-weren-t-written-down---VmlldzoxMjY3MDk5',
        onClick: () => {
          window.analytics?.track('See Example Clicked', {
            location: 'empty reports tab',
          });
          window.analytics?.track('See Example Clicked', {
            location: 'reports empty tab',
          });
        },
      }}
      primaryAction={
        isAnonymous
          ? undefined
          : {
              content: 'Create report',
              onClick: () => {
                createReport('empty reports tab');
              },
            }
      }
    />
  );
};
